// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"a8080cdf","71":"5ce08fc6","249":"ac88d4d7","791":"6f0da282","886":"18ab0550"}[chunkId] + ".js";
};